import styled from "@emotion/styled";

export const HeaderTitle = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  font-weight: bold;
  border-bottom: 1px;
`;
